import React from 'react';
import './Services.css';

function Services({ activeService, setActiveService }) {
  const services = [
    {
      id: 'drawing',
      icon: '🎨',
      title: 'AI 绘图定制',
      description: '使用最新的 Stable Diffusion 和 DALL-E 技术，为您生成独特的艺术作品。只需描述您的想法，AI 即可创作出专业级别的图像。',
      features: [
        '多种艺术风格选择',
        '高质量图像生成',
        '快速交付（1-5分钟）',
        '支持批量生成',
        '商业使用授权'
      ],
      price: '¥29/张'
    },
    {
      id: 'writing',
      icon: '✍️',
      title: 'AI 写作服务',
      description: '基于 GPT-4 和 Claude 的强大 AI 写作助手，帮您创作文章、营销文案、技术文档等各类内容。',
      features: [
        '多种文体支持',
        'SEO 优化建议',
        '多语言支持',
        '实时协作编辑',
        '无限制修改'
      ],
      price: '¥0.1/字'
    },
    {
      id: 'logo',
      icon: '🎯',
      title: 'AI Logo 生成',
      description: '快速生成专业的企业 Logo 设计。输入您的品牌信息，AI 将为您创建多个设计方案，助您打造独特的品牌形象。',
      features: [
        '多种设计风格',
        '矢量格式输出',
        '品牌配色方案',
        '字体建议',
        '全套品牌素材'
      ],
      price: '¥199/套'
    }
  ];

  return (
    <section id="services" className="services section">
      <div className="container">
        <div className="services__header">
          <h2 className="section__title">我们的 AI 服务</h2>
          <p className="section__subtitle">
            使用最先进的 AI 技术，为您的业务提供专业解决方案
          </p>
        </div>

        <div className="services__grid">
          {services.map((service) => (
            <div
              key={service.id}
              className={`service-card ${activeService === service.id ? 'service-card--active' : ''}`}
              onClick={() => setActiveService(activeService === service.id ? null : service.id)}
            >
              <div className="service-card__icon">{service.icon}</div>
              <h3 className="service-card__title">{service.title}</h3>
              <p className="service-card__description">{service.description}</p>
              
              <div className="service-card__features">
                {service.features.map((feature, index) => (
                  <div key={index} className="feature-item">
                    <span className="feature-check">✓</span>
                    <span>{feature}</span>
                  </div>
                ))}
              </div>

              <div className="service-card__footer">
                <div className="service-card__price">{service.price}</div>
                <button className="btn btn--primary">立即使用</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;

